import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Shell } from '@/components/layout/Shell';
import { useAuth } from '@/lib/auth';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
});

function AppLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-bg">
        <div className="text-fg-muted text-sm font-mono">Carregando…</div>
      </div>
    );
  }

  if (!user) {
    // Client-side redirect because beforeLoad needs context wiring
    window.location.href = '/login';
    return null;
  }

  return (
    <Shell>
      <Outlet />
    </Shell>
  );
}
